// extracted by mini-css-extract-plugin
export default {"blockWrapper":"LoginAndRegistration_blockWrapper__MrNmN","modal":"LoginAndRegistration_modal__Gg16d"};